import { Box} from '@chakra-ui/react'
import NewLanguageForm from './components/NewLanguageForm'
import { useEffect, useState } from 'react'
import { getLanguages } from 'src/view-models/Languages'
import { useDispatch } from 'react-redux'
import Loading from 'src/components/loading/Loading'

const NewLanguage = () => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchLanguages = async () => {
      await getLanguages(dispatch)
      setIsLoading(false)
    }
    fetchLanguages()
  }, [])

  if (isLoading) {
    return <Loading />
  }

  return (
    <Box px={4} py={2} rounded={4} >
        <Box backgroundColor='white' p={8} boxShadow='md' >
          <NewLanguageForm />
        </Box>
    </Box>
  )
}

export default NewLanguage